import { Commit } from 'vuex';
import { SuiviInterventionState } from './state';

export enum SuiviInterventionActions {
    GET_SUIVIS_INTERVENTION = 'GET_SUIVIS_INTERVENTION',
    NAV_FILTER = 'NAV_FILTER_INTERVENTION',
    EXPORT_XLS_INTERVENTIONS = 'EXPORT_XLS_INTERVENTIONS',
}

export interface SuiviInterventionActionTypes{
    commit: Commit,
    state: SuiviInterventionState,
    getters: any
}
